import { QuoteType } from './quote.model';

export interface EnquiryConfig {
  portalId: number;
  clientId: number;
  type: QuoteType;
  selectedProducts: EnquiryProductConfig[];
}

export interface EnquiryConfigUpdate {
  quoteId: number;
  selectedProducts: EnquiryProductConfig[];
}

export interface EnquiryProductConfig {
  id: number;
  inceptionDate: string;
  expiryDate: string;
  renewalDate: string;
  subType?: string | undefined;
}

export interface EnquiryConfigurationConfig {
  steps: ENQUIRY_CONFIGURATION_STEPS[];
}

export enum ENQUIRY_CONFIGURATION_STEPS {
  Adjustments,
  Endorsements,
}

export type EnquiryConfigurationStep =
  (typeof ENQUIRY_CONFIGURATION_STEPS)[keyof typeof ENQUIRY_CONFIGURATION_STEPS];
